import { Tabs, Tab } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SiniestroStatus } from '../types/siniestros.types';

interface MenuTabsProps {
    value: SiniestroStatus;
    onChange: (value: SiniestroStatus) => void;
    soloTodos?: boolean;
}

const tabStyles = {
    fontSize: '1rem',
    fontWeight: 'bold',
    px: 4,
    py: 2,
    textTransform: 'none'
};

const MenuTabs: FC<MenuTabsProps> = ({ value, onChange, soloTodos = false }) => {
    const { t } = useTranslation('siniestrosRoam');

    return (
        <Tabs value={value} onChange={(_, newValue) => onChange(newValue)}>
            <Tab value="ALL" label={t('tabs.all')} sx={tabStyles} />
            {!soloTodos && <Tab value="PENDING" label={t('tabs.pending')} sx={tabStyles} />}
            {!soloTodos && <Tab value="OPEN" label={t('tabs.open')} sx={tabStyles} />}
            {!soloTodos && <Tab value="FINALIZED" label={t('tabs.finalized')} sx={tabStyles} />}
            {!soloTodos && <Tab value="CANCELLED" label={t('tabs.cancelled')} sx={tabStyles} />}
        </Tabs>
    );
};

export default MenuTabs;
